import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import CustomerVehicleSearch from '../../search/CustomerVehicleSearch';

export default function FormInputCustomerVehicleSearch(props) {
  return <FormInputSearch {...props} searchComponent={CustomerVehicleSearch} />;
}
